// Natural, case-insensitive alphabetical sort (handles "Khata 2" vs "Khata 10" correctly).
const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });

export function sortedByName(list, keyFn = (item) => item?.name) {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => collator.compare(String(keyFn(a) ?? ''), String(keyFn(b) ?? '')));
}
